import { useState,useMemo, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import WineContainer from '../../Components/WineContainer/WineContainer';
import { fetchWines, fetchProducts } from '../../Services/WineService'
import { Products, Wine } from '../../Model/types';
import './WinesPage.css'

const WinesPage = () => {
  const [wines, setWines] = useState<Wine[]>([]);
  const [products, setProducts] = useState<Products[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const openSection = searchParams.get("open") || ""; // ej: "1"
  const lastWineId = searchParams.get("wineId");      // ej: "12"
  
  const openSectionId = openSection ? Number(openSection) : null;

  useEffect(() => {getWines()}, []);
  useEffect(() => {getProducts()}, []);
  
  useEffect(() => {
    if (!lastWineId) return;

    const el = document.getElementById(`wine-${lastWineId}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [lastWineId, wines.length]);


const toggleSection = (id: number) => {
  setSearchParams((prev) => {
    const next = new URLSearchParams(prev);

    if (Number(next.get("open")) === id) {
      next.delete("open");
    } else {
      next.set("open", id.toString());
    }

    return next;
  });
};
  const getWines = async () => {
    try {
      const data = await fetchWines();
      setWines(data);
    } catch (error) {
      console.error('Error al cargar los vinos:', error);
    } 
  };


  const getProducts = async () => {
    try {
      const data = await fetchProducts();
      
      setProducts(data);
    } catch (error) {
      console.error('Error al cargar los vinos:', error);
    } 
  };


   return (
    <div className="page">
      {products.map((product) => {
        const winesForThisProduct = wines.filter((wine) => wine.productId === product.id);
        if (winesForThisProduct.length === 0) return null;
        return (
          <WineContainer
            key={product.id}
            title={product.product}
            wines={winesForThisProduct}
            color={product.color ?? "#E2BF81"}
            isOpen={openSectionId === product.id}
            onToggle={() => toggleSection(product.id)}
          />
        );
      })}

      <WineContainer
        title="Todos"
        wines={wines}
        color="#E2BF81"
        isOpen={openSection === "99"}
        onToggle={() => toggleSection(99)}
      />
    </div>
  );
};

export default WinesPage;